import type { QueryPayload } from "../types";

/** Client-only: never sent to the API. Skips global toaster / notification on request failure (used before a known fallback). */
export const GET_BY_UID_SUPPRESS_USER_ERROR_KEY = "suppressUserFacingErrorOnFailure" as const;

export function prepareGetByUidQueryForRequest(q: QueryPayload | undefined): {
	requestQuery: QueryPayload | undefined;
	suppressUserFacingErrorOnFailure: boolean;
} {
	if (!q || typeof q !== "object" || Array.isArray(q)) {
		return { requestQuery: q, suppressUserFacingErrorOnFailure: false };
	}
	const record = { ...(q as Record<string, unknown>) };
	const suppress = record[GET_BY_UID_SUPPRESS_USER_ERROR_KEY] === true;
	delete record[GET_BY_UID_SUPPRESS_USER_ERROR_KEY];
	const keys = Object.keys(record);
	return {
		requestQuery: keys.length > 0 ? (record as QueryPayload) : undefined,
		suppressUserFacingErrorOnFailure: suppress,
	};
}
